import { getActionProps } from './actionProps';
import TextWithButton from './TextWithButton';

export default function TextWithActionButton({loadingButton, variant = "outlined", handleClick, border = false, type = "primaryAction", children, sx = {}, ...rest}) {

    const combinedSx = {
        ...sx,
        ...(!border && {
            border: '0px'
        }),
    }
    const props = {
        ...getActionProps(type, combinedSx),
        ...rest,
        variant,
    }

    return (
        <TextWithButton {...props}>{children}</TextWithButton>
    )

}
